import { gtmEvent } from "../gtm-event";

/**
 * Custom search event to add type as well as term
 *
 * @param search_type - a prefix so we can group the search
 * @param searchTerm - search string used
 */
export const gtmSearchEvent = (searchType: string, searchTerm: string): void => {
  gtmEvent<"search", { search_type: string }>("search", {
    search_term: searchTerm,
    search_type: searchType
  });
};
